import { useSyncExternalStore } from 'react';
import { getBids, subscribe, type Bid } from './bidStore';

/**
 * Subscribe to the bid store. Re-renders whenever bids are added, updated, or
 * deleted anywhere in the app.
 */
export function useBids(): Bid[] {
  return useSyncExternalStore(subscribe, getBids, getBids);
}
